import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Kết quả xét tuyển sinh liên thông", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "row g-5 g-xl-8" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "card mb-5 mb-xl-8" }
const _hoisted_14 = { class: "card-header border-0 pt-2 umt-form" }
const _hoisted_15 = {
  key: 0,
  class: "w-100 d-flex align-items-center justify-content-between flex-wrap gap-3 bg-light-primary rounded px-4 py-3 mt-4 mb-1"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-start flex-grow-1\"><i class=\"bi bi-info-circle-fill text-primary fs-4 me-3 mt-1\"></i><div class=\"fs-7 text-gray-700\"><span class=\"fw-bolder text-gray-800\">Kết quả dự kiến trúng tuyển liên thông.</span> Kiểm tra (tick chọn nếu chỉ xử lý một phần) rồi: <b class=\"text-primary\">Xác nhận trúng tuyển</b> để chốt chính thức · <b class=\"text-danger\">Xét tuyển lại</b> để làm lại · <b>Xuất Excel</b> trong menu ⋮.</div></div>", 1)
const _hoisted_17 = { class: "card-title gap-3 flex-wrap" }
const _hoisted_18 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_19 = { class: "svg-icon svg-icon-3 position-absolute ms-4" }
const _hoisted_20 = {
  key: 1,
  class: "card-toolbar"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, null, -1)
const _hoisted_22 = {
  type: "button",
  class: "btn btn-primary me-3 d-none",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_admission_confirmation",
  ref: "kt_modal_click_admission_confirm"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, null, -1)
const _hoisted_26 = {
  type: "button",
  class: "btn btn-danger me-3 d-none",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_reexamination",
  ref: "kt_modal_re_exam"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div><button type=\"button\" class=\"btn btn-icon btn-sm btn-secondary\" data-kt-menu-trigger=\"click\" data-kt-menu-placement=\"bottom-end\" data-kt-menu-flip=\"top-end\"><i class=\"bi bi-three-dots-vertical\"></i></button><div class=\"menu menu-sub menu-sub-dropdown w-250px py-2 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold dropdown-menu\" data-kt-menu=\"true\"><div data-bs-toggle=\"modal\" data-bs-target=\"#kt_modal_export_result\" class=\"menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary\"><i class=\"bi bi-box-arrow-down fs-5 me-3 text-gray-500\"></i>Xuất Excel </div></div></div>", 1)
const _hoisted_30 = { class: "card-body pt-0 umt-table umt-table-compact" }
const _hoisted_31 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "text-center menu-link text-gray-600" }
const _hoisted_34 = { class: "text-center menu-link text-gray-600" }
const _hoisted_35 = { class: "menu-link text-gray-600" }
const _hoisted_36 = { class: "menu-link text-gray-600" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 1,
  class: "menu-link text-gray-800 fw-bold text-nowrap"
}
const _hoisted_39 = { class: "menu-link text-gray-600" }
const _hoisted_40 = { class: "menu-link text-start text-gray-600" }
const _hoisted_41 = { class: "menu-link text-start text-gray-600" }
const _hoisted_42 = { class: "menu-link text-start text-gray-600" }
const _hoisted_43 = {
  key: 0,
  class: "svg-icon svg-icon-2 svg-icon-primary",
  title: "Đợt bổ sung"
}
const _hoisted_44 = {
  class: "modal fade",
  id: "kt_modal_export_result",
  ref: "addExporResultModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_45 = { class: "modal-dialog modal-dialog-centered mw-550px" }
const _hoisted_46 = { class: "modal-content" }
const _hoisted_47 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Xuất kết quả trúng tuyển", -1)
const _hoisted_49 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_50 = { class: "svg-icon svg-icon-1" }
const _hoisted_51 = { class: "modal-body py-4 px-lg-6 umt-form" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-start bg-light-primary rounded px-4 py-3 mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill text-primary fs-4 me-3 mt-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-gray-700" }, [
    /*#__PURE__*/_createTextVNode("Chọn "),
    /*#__PURE__*/_createElementVNode("b", null, "phạm vi"),
    /*#__PURE__*/_createTextVNode(" cần xuất — để \"Tất cả\" nếu muốn xuất toàn bộ. File Excel tải về ngay sau khi bấm "),
    /*#__PURE__*/_createElementVNode("b", null, "Xuất Excel"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1)
const _hoisted_53 = { class: "row g-4" }
const _hoisted_54 = { class: "col-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Đợt", -1)
const _hoisted_56 = { class: "col-6" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Ngành", -1)
const _hoisted_58 = { class: "col-6" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nguyện vọng", -1)
const _hoisted_60 = { class: "col-6" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Loại trúng tuyển", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end pt-4 mt-4 border-top border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "btn btn-light umt-btn-32 me-2",
    "data-bs-dismiss": "modal"
  }, "Hủy bỏ"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary umt-btn-32",
    type: "submit"
  }, " Xuất Excel ")
], -1)
const _hoisted_63 = {
  class: "modal fade",
  id: "kt_modal_reexamination",
  ref: "kt_modal_reexamination",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_64 = { class: "modal-dialog modal-dialog-centered mw-450px" }
const _hoisted_65 = { class: "modal-content" }
const _hoisted_66 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Xét tuyển lại", -1)
const _hoisted_68 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_69 = { class: "svg-icon svg-icon-1" }
const _hoisted_70 = { class: "modal-body py-4 px-lg-6 umt-form" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-start bg-light-danger rounded px-4 py-3 mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-danger fs-4 me-3 mt-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-gray-700" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800" }, "Hủy kết quả trúng tuyển liên thông"),
    /*#__PURE__*/_createTextVNode(" của các hồ sơ trong phạm vi bên dưới — hồ sơ quay về danh sách chờ xét để xét lại từ đầu.")
  ])
], -1)
const _hoisted_72 = { class: "fv-row mb-3" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Đợt", -1)
const _hoisted_74 = { class: "text-muted fs-7 mb-4" }
const _hoisted_75 = { class: "fw-bolder text-gray-800" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end pt-3 border-top border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "btn btn-light umt-btn-32 me-2",
    "data-bs-dismiss": "modal"
  }, "Hủy bỏ"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-danger umt-btn-32",
    type: "submit"
  }, " Xét tuyển lại ")
], -1)
const _hoisted_77 = {
  class: "modal fade",
  id: "kt_modal_admission_confirmation",
  ref: "kt_modal_admission_confirmation",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_78 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_79 = { class: "modal-content" }
const _hoisted_80 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Xác nhận trúng tuyển", -1)
const _hoisted_82 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_83 = { class: "svg-icon svg-icon-1" }
const _hoisted_84 = { class: "modal-body py-4 px-lg-6 umt-form" }
const _hoisted_85 = { class: "row g-4 mb-4" }
const _hoisted_86 = { class: "col-6" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Đợt xác nhận", -1)
const _hoisted_88 = { class: "col-6 d-flex align-items-end" }
const _hoisted_89 = { class: "text-muted fs-7 pb-2" }
const _hoisted_90 = { class: "fw-bolder text-gray-800" }
const _hoisted_91 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded p-4 mb-4"
}
const _hoisted_92 = {
  class: "text-gray-800 mb-3",
  style: {"font-weight":"700"}
}
const _hoisted_93 = { class: "badge badge-light-success ms-1" }
const _hoisted_94 = { class: "row g-4" }
const _hoisted_95 = { class: "col-6" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Số QĐ", -1)
const _hoisted_97 = { class: "col-6" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Ngày QĐ", -1)
const _hoisted_99 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded p-4 mb-4"
}
const _hoisted_100 = {
  class: "text-gray-800 mb-3",
  style: {"font-weight":"700"}
}
const _hoisted_101 = { class: "badge badge-light-warning ms-1" }
const _hoisted_102 = { class: "row g-4" }
const _hoisted_103 = { class: "col-6" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Số QĐ", -1)
const _hoisted_105 = { class: "col-6" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Ngày QĐ", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end pt-3 border-top border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "btn btn-light umt-btn-32 me-2",
    "data-bs-dismiss": "modal"
  }, "Hủy bỏ"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary umt-btn-32",
    type: "submit"
  }, " Xác nhận ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_FlowNav = _resolveComponent("FlowNav")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_HoSoQuickDrawer = _resolveComponent("HoSoQuickDrawer")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
            [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW,_ctx.Permission.DASHBOARD]]
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light ms-auto umt-btn-32",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, [
          _hoisted_9,
          _createTextVNode("Quay lại ")
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_ctx.tableData.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_router_link, {
                        to: "/danhsachtrungtuyen",
                        class: "btn btn-sm btn-light-primary text-nowrap ms-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Danh sách trúng tuyển →")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                      class: "form-control form-control-solid w-225px ps-11",
                      placeholder: "Tìm kiếm hồ sơ...",
                      style: {"height":"32px","min-height":"32px","padding-top":"0","padding-bottom":"0","font-size":"13px"}
                    }, null, 512), [
                      [_vModelText, _ctx.search]
                    ])
                  ]),
                  _createVNode(_component_FlowNav, {
                    flow: "lienthong",
                    current: 1
                  })
                ]),
                (_ctx.tableData.length !=0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary btn-sm me-3 umt-btn-32",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.modalAdmissionConfirmation && _ctx.modalAdmissionConfirmation(...args)))
                      }, [
                        _hoisted_21,
                        _createTextVNode(" Xác nhận trúng tuyển" + _toDisplayString(_ctx.checkedCustomers.length ? ` (${_ctx.checkedCustomers.length} đã chọn)` : ''), 1)
                      ]),
                      _createElementVNode("button", _hoisted_22, _hoisted_24, 512),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger btn-sm me-3 umt-btn-32",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.modalReexamination && _ctx.modalReexamination(...args)))
                      }, [
                        _hoisted_25,
                        _createTextVNode(" Xét tuyển lại" + _toDisplayString(_ctx.checkedCustomers.length ? ` (${_ctx.checkedCustomers.length} đã chọn)` : ''), 1)
                      ]),
                      _createElementVNode("button", _hoisted_26, _hoisted_28, 512),
                      _hoisted_29
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_30, [
                (_ctx.tableData.length!=0)
                  ? (_openBlock(), _createBlock(_component_Datatable, {
                      key: 0,
                      "table-data": _ctx.tableData,
                      total: _ctx.tableData.length,
                      currentPage: _ctx.pagination.currentPage,
                      "table-header": _ctx.tableHeader,
                      "rows-per-page": _ctx.pagination.limit,
                      "enable-items-per-page-dropdown": true,
                      onCurrentCheckAll: _ctx.checkAll,
                      isCheck: _ctx.checkDefault
                    }, {
                      "cell-checkbox": _withCtx(({ row: customer }) => [
                        _createElementVNode("div", _hoisted_31, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input form-auto-check",
                            type: "checkbox",
                            value: customer.id,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkedCustomers) = $event))
                          }, null, 8, _hoisted_32), [
                            [_vModelCheckbox, _ctx.checkedCustomers]
                          ])
                        ])
                      ]),
                      "cell-index": _withCtx(({ row: customer }) => [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(customer.index), 1)
                      ]),
                      "cell-phase": _withCtx(({ row: customer }) => [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(customer.phase), 1)
                      ]),
                      "cell-priority": _withCtx(({ row: customer }) => [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(customer.priority), 1)
                      ]),
                      "cell-adMajor": _withCtx(({ row: customer }) => [
                        _createElementVNode("div", _hoisted_36, _toDisplayString(customer.adMajor), 1)
                      ]),
                      "cell-profileCode": _withCtx(({ row: customer }) => [
                        _createElementVNode("div", {
                          class: "menu-link text-primary fw-bold cursor-pointer position-relative",
                          title: "Xem nhanh hồ sơ",
                          onClick: ($event: any) => (_ctx.openQuickView(customer))
                        }, _toDisplayString(customer.profileCode), 9, _hoisted_37)
                      ]),
                      "cell-fullName": _withCtx(({ row: customer }) => [
                        (customer.idStudent)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/danhsachungvien/${customer.idStudent}`,
                              class: "menu-link text-gray-800 fw-bold text-hover-primary text-nowrap",
                              title: "Mở chi tiết ứng viên"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.titleCaseName(customer.fullName)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.titleCaseName(customer.fullName)), 1))
                      ]),
                      "cell-idCard": _withCtx(({ row: customer }) => [
                        _createElementVNode("div", _hoisted_39, _toDisplayString(customer.idCard), 1)
                      ]),
                      "cell-adMethod": _withCtx(({ row: customer }) => [
                        _createElementVNode("div", _hoisted_40, _toDisplayString(customer.adMethod), 1)
                      ]),
                      "cell-score": _withCtx(({ row: customer }) => [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(customer.score), 1)
                      ]),
                      "cell-typeAdmission": _withCtx(({ row: customer }) => [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("span", {
                            class: _normalizeClass(`m-auto badge badge-light-${_ctx.arrTag[customer.typeAdmission]?.state}`)
                          }, _toDisplayString(_ctx.arrTag[customer.typeAdmission]?.label), 3),
                          (customer.isExtra)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen013.svg" })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page", "onCurrentCheckAll", "isCheck"]))
                  : (_openBlock(), _createBlock(_component_Datatable, {
                      key: 1,
                      "table-data": [],
                      total: _ctx.tableData.length,
                      currentPage: _ctx.pagination.currentPage,
                      "table-header": _ctx.tableHeader,
                      "rows-per-page": _ctx.pagination.limit,
                      "enable-items-per-page-dropdown": true,
                      loading: _ctx.loading
                    }, null, 8, ["total", "currentPage", "table-header", "rows-per-page", "loading"]))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("span", _hoisted_50, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.formData,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid w-100",
                        placeholder: "Đợt dự kiến",
                        "popper-class": "umt-form-dd",
                        modelValue: _ctx.formData.phase,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.phase) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrPhase, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id ,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid w-100",
                        placeholder: "Ngành",
                        filterable: true,
                        "popper-class": "umt-form-dd",
                        modelValue: _ctx.formData.majorId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.majorId) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid w-100",
                        placeholder: "Nguyện vọng",
                        "popper-class": "umt-form-dd",
                        modelValue: _ctx.formData.priority,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.priority) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Tất cả",
                            value: "0"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Nguyện vọng 1",
                            value: "1"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Nguyện vọng 2",
                            value: "2"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Nguyện vọng 3",
                            value: "3"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid w-100",
                        placeholder: "Loại trúng tuyển",
                        "popper-class": "umt-form-dd",
                        modelValue: _ctx.formData.typeAdmission,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.typeAdmission) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Tất cả",
                            value: "0"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Chính thức",
                            value: "graduated"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Có điều kiện",
                            value: "not_graduated"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_62
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("span", _hoisted_69, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submitReExamination()), ["prevent"])),
              model: _ctx.formDataReExam,
              ref: "formDataReExam"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid w-100",
                      placeholder: "Đợt dự kiến",
                      "popper-class": "umt-form-dd",
                      modelValue: _ctx.formData.phase,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.phase) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrPhaseReAdmission, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createTextVNode(" Áp dụng: "),
                    _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.checkedCustomers.length ? `${_ctx.checkedCustomers.length} hồ sơ đã chọn` : 'toàn bộ hồ sơ liên thông thuộc đợt'), 1)
                  ]),
                  _hoisted_76
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_77, [
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _hoisted_81,
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("span", _hoisted_83, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.submitFormDataconfirm()), ["prevent"])),
              model: _ctx.formDataAuth,
              rules: _ctx.rules,
              ref: "formDataconfirm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      _hoisted_87,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid w-100",
                        placeholder: "Đợt dự kiến",
                        "popper-class": "umt-form-dd",
                        modelValue: _ctx.formData.phase,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.phase) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrPhaseReAdmission, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createTextVNode("Áp dụng: "),
                        _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.checkedCustomers.length ? `${_ctx.checkedCustomers.length} hồ sơ đã chọn` : 'toàn bộ hồ sơ thuộc đợt'), 1)
                      ])
                    ])
                  ]),
                  (_ctx.statOfficial != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                        _createElementVNode("div", _hoisted_92, [
                          _createTextVNode(" Trúng tuyển chính thức "),
                          _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.statOfficial) + " hồ sơ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _hoisted_96,
                            _createVNode(_component_el_form_item, { prop: "code" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  modelValue: _ctx.formDataAuth.code,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formDataAuth.code) = $event)),
                                  name: "code",
                                  placeholder: "Số quyết định"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _hoisted_98,
                            _createVNode(_component_el_form_item, { prop: "dayOfDecision" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  class: "w-100",
                                  modelValue: _ctx.formDataAuth.dayOfDecision,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formDataAuth.dayOfDecision) = $event)),
                                  name: "dayOfDecision",
                                  placeholder: "Ngày/tháng/năm",
                                  format: "DD/MM/YYYY"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.statConditional != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                          _createTextVNode(" Trúng tuyển có điều kiện "),
                          _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.statConditional) + " hồ sơ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("div", _hoisted_103, [
                            _hoisted_104,
                            _createVNode(_component_el_form_item, { prop: "code2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  modelValue: _ctx.formDataAuth.code2,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formDataAuth.code2) = $event)),
                                  name: "code2",
                                  placeholder: "Số quyết định"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_105, [
                            _hoisted_106,
                            _createVNode(_component_el_form_item, { prop: "dayOfDecision2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  class: "w-100",
                                  modelValue: _ctx.formDataAuth.dayOfDecision2,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formDataAuth.dayOfDecision2) = $event)),
                                  name: "dayOfDecision2",
                                  placeholder: "Ngày/tháng/năm",
                                  format: "DD/MM/YYYY"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_107
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_HoSoQuickDrawer, { ref: "quickDrawer" }, null, 512)
  ], 64))
}